<template>
  <base-form-modal
    :show="show"
    :title="title"
    :ok-text="okText"
    :cancel-text="cancelText"
    :show-cancel-button="showCancelButton"
    :dismiss-btn="dismissBtn"
    @show="open"
    @close="$emit('close')"
    @beforeSubmit="bool => beforeSubmitTrigger = bool"
  >
    <form-modal
      ref="form"
      v-model="model"
      :is-before-submit="beforeSubmitTrigger"
    />
  </base-form-modal>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/api'
import BaseFormModal from '@/components/share/modal/BaseFormModal'
import FormModalMixin from '@/components/share/modal/FormModalMixin'
import CommentMixin from '@/components/bundles/share/comment/CommentMixin.js'
import FormModal from '@/components/bundles/share/comment/form/CommentInspectionDateForm'
import ValidatorReset from '@/components/share/mixins/ValidatorReset'
import { createStrategy } from '@/components/bundles/share/comment/commentStrategies.js'

export default {
  name: 'CommentInspectionDateModal',
  components: {
    FormModal,
    BaseFormModal
  },
  mixins: [
    CommentMixin,
    FormModalMixin,
    ValidatorReset
  ],
  props: {
    service: { type: String, required: true, default: '' },
    commentType: { type: String, default: 'inspection_date' },
    commentId: { type: [String, Number], default: null },
    supportedClass: { type: String, default: 'appraisal' },
    taskData: {
      type: Object,
      default: () => ({})
    },
    showCancelButton: { type: Boolean, default: true },
    dismissBtn: { type: Boolean, default: true }
  },
  data () {
    return {
      sending: false,
      title: this.$t('pages.taskDetails.comments.modal.inspection.reasonTitle.late', {nDays: 2})
    }
  },
  computed: {
    currentCommentTypeConfig () {
      return this.commentTypesList?.find(item => item.type === this.commentType) || {}
    },
    strategy () {
      return createStrategy(this.service, {
        taskId: this.$route.params.appraisalTaskId,
        supportedClass: this.supportedClass,
        commentType: this.commentType,
        commentTypeConfig: this.currentCommentTypeConfig,
        message: this.model.message,
        commentId: this.commentId
      })
    },
    actionUrl () {
      return this.strategy.url
    },
    httpMethod () {
      return this.strategy.method
    }
  },
  methods: {
    ...mapActions([
      'fetchRules'
    ]),
    submitForm () {
      api.request(this.service, this.httpMethod, this.actionUrl, this.createDataToSend())
        .then(() => {
          this.$notify({
            type: 'success',
            text: this.strategy.isEdit ? this.$t('pages.taskDetails.comments.editComment') : this.$t('pages.taskDetails.comments.addComment')
          })
        })
        .catch((error) => {
          this.errorNotify(error)
        })
        .finally(() => this.fetchRules({ service: this.service, taskId: this.$route.params.appraisalTaskId }))
    },
    createDataToSend () {
      const metadata = {
        changedFields: {
          inspectedAt: this.taskData.inspectedAt
        }
      }

      return this.strategy.formatPayload(metadata)
    }
  }
}
</script>
